module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon5.png?892b0f57";